import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const LOCK_OFFER_MUTATION = gql`
mutation lockQuote($documentVersion: DocumentVersionInput!) {
  quotes {
    lock(documentVersion: $documentVersion) {
      documentId
      revisions {
        revision
        status
        snkModifier {
          profile {
            firstName
            lastName
          }
        }
        priceIsOutdated
        autoUpdatePrices
        locked
      }
    }
  }
}
`;

@Injectable({
  providedIn: 'root'
})
export class LockOfferMutation extends Mutation<RootMutation> {
  document = LOCK_OFFER_MUTATION;
}
